import { render, staticRenderFns } from "./PickupAlert.vue?vue&type=template&id=862896a2&"
import script from "./PickupAlert.vue?vue&type=script&lang=js&"
export * from "./PickupAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports